module.exports = __webpack_public_path__ + "static/media/icon-trash-black.ff87e221.svg";